const ReportsConstants = {
  ALL: "all",
  ACTIVATE: "activate",
  ACTIVE: "active",
  CLOSE: "close",
  DEACTIVATE: "deactivate",
  EDIT: "edit",
  INACTIVE: "inactive",
  NO_VALUE: "--",
  SAVE: "save",
  REPORT_TYPES: {
    ALL_DIMENSIONS_AND_METRICS: "all_dimensions_and_metrics",
    ALL_DIMENSIONS_AND_METRICS_ECOSYSTEM_COST:
      "all_dimensions_and_metrics_ecosystem_cost",
    APP_TRANSPARENCY: "app_transparency",
    AUDIENCE_INDEX: "audience_index",
    AUDIENCE_INDEX_PIXEL: "audience_index_pixel",
    BRAIN_FEATURE_SUMMARY: "brain_feature_summary",
    BRAIN_FEATURE_VALUE: "brain_feature_value",
    BY_HOUR: "by_hour",
    CONTEXTUAL_INSIGHTS: "contextual_insights",
    DATA_PIXEL_LOADS: "data_pixel_loads",
    DAY_PART: "day_part",
    DEVICE_TECHNOLOGY: "device_technology",
    EVENT_PIXEL_LOADS: "event_pixel_loads",
    GEO: "geo",
    HYPERLOCAL: "hyperlocal",
    PERFORMANCE: "performance",
    POSTAL_CODE: "postal_code",
    REACH_FREQUENCY: "reach_frequency",
    SITE_TRANSPARENCY: "site_transparency",
    SITE_TRANSPARENCY_VIEWABILITY: "site_transparency_viewability",
    WATERMARK: "watermark",
    WIN_LOSS: "win_loss",
    WIN_LOSS_CREATIVE: "win_loss_creative",
  },
  REPORT_DATE_RANGES: {
    LAST_7_HOURS_INCLUSIVE: "last_7_hours_inclusive",
    YESTERDAY: "yesterday",
    LAST_1_DAYS: "last_1_days",
    LAST_X_DAYS: "last_X_days",
    LAST_7_DAYS: "last_7_days",
    LAST_14_DAYS: "last_14_days",
    LAST_30_DAYS: "last_30_days",
    LAST_45_DAYS: "last_45_days",
    MONTH_TO_DATE: "month_to_date",
    CAMPAIGN_TO_DATE: "campaign_to_date",
  },
  EXPORT_COOLDOWN_MS: 30 * 1000,
};

export default ReportsConstants;
